import request from "@/utils/request.js";

// 个人用户验证
export function valiisusr(data) {
  return request({
    url: "/isp/user/checkoldpass",
    method: "get",
    params: data,
  });
}

// 个人用户登陆
export function login(params) {
  return request({
    url: "/api/user/login",
    method: "GET",
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    params,
  });
}
// 个人用户登陆
export function isentlogin(data) {
  return request({
    url: "/isentlogin",
    method: "post",
    data,
  });
}
// 退出
export function logout() {
  return request({
    url: "/infor/quit",
    method: "get",
  });
}

// 企业用户注册
export function entuserAdd(data) {
  return request({
    url: "/isp/entuser/add",
    method: "post",
    data,
  });
}
// 企业用户验证
export function entuserValiisusr(data) {
  return request({
    url: "/dev-api/isp/entuser/checkoldpass",
    method: "get",
    params: data,
  });
}

// /dev-api/isp/app/add
export function appAdd(data) {
  return request({
    url: "/isp/app/add",
    method: "post",
    data,
  });
}
// /dev-api/isp/app/list
export function getAppList() {
  return request({
    url: "/isp/app/list",
    method: "get",
  });
}
